import { Inbox } from 'lucide-react';
import { cn } from '../lib/cn.js';

/**
 * Empty states speak with Nova's voice — competent and brief, never apologetic.
 * Example from the design system: «Ingen forsinkelser. Slik skal det se ut.»
 */
export function EmptyState({
  title,
  description,
  icon,
  action,
  className,
}: {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('flex flex-col items-center px-6 py-10 text-center', className)}>
      <span className="text-ink-soft/70 mb-3">{icon ?? <Inbox size={26} strokeWidth={1.5} />}</span>
      <p className="font-display text-ink text-sm">{title}</p>
      {description && <p className="text-ink-soft mt-1.5 max-w-sm text-sm">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function ErrorState({
  title = 'Noe gikk galt',
  description,
  onRetry,
}: {
  title?: string;
  description?: string;
  onRetry?: () => void;
}) {
  return (
    <EmptyState
      title={title}
      description={description ?? 'Jeg fikk ikke hentet dataene. Prøv igjen om et øyeblikk.'}
      action={
        onRetry && (
          <button
            type="button"
            onClick={onRetry}
            className="border-hairline bg-raised text-ink hover:bg-raised/70 rounded-lg border px-3 py-1.5 text-sm transition"
          >
            Prøv igjen
          </button>
        )
      }
    />
  );
}
